import { useGetLocationConfiguration } from "#/requests/get-location";
import useErrorConfigurationStore from "#/stores/error-configuration.store";
import {
  Button,
  Highlighter,
  Layout,
  MaskedInput,
  Modal,
  Paragraph,
  Spacing,
  Title,
} from "@sicredi/react";
import React, { useEffect, useState } from "react";
import styles from "#/components/Header/styles.module.scss";
import useLocationConfigurationStore from "#/stores/location-configuration.store";
type Props = {
  open?: boolean;
};
export default function ModalLocationConfiguration({ open }: Props) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [cep, setCep] = useState("");
  const { data } = useGetLocationConfiguration({
    zipCode: cep,
  });
  const { locationConfiguration } = useLocationConfigurationStore();
  const { errorConfiguration } = useErrorConfigurationStore();

  useEffect(() => {
    setIsOpen(open ?? false);
  }, [open]);

  useEffect(() => {
    if (cep !== "" && data !== undefined) {
      setIsOpen(open ?? false);
    }
  }, [cep, data, open]);
  function handlerOffers(event: any): void {
    if (event.currentTarget.value.length === 9) {
      setCep(event.currentTarget.value.replace("-", ""));
    }
  }
  function handlerOpen(): void {
    if (cep !== "" && data !== undefined) {
      setIsOpen(!isOpen);
    }
  }
  return (
    <div data-testid="modalLocation">
      <Button
        data-testid="button-modal-location"
        className={styles["on-hover-no-blur"]}
        size="small"
        appearance="link"
        ghost
        onClick={() => setIsOpen(!isOpen)}
      >
        <Paragraph
          style={{ color: "#3FA111", marginLeft: "8px", fontSize: "12px" }}
        >
          <Highlighter.BoldText>
            {locationConfiguration
              ? `${locationConfiguration?.cidade} - ${locationConfiguration?.uf}`
              : "(insira o CEP aqui)"}
          </Highlighter.BoldText>
        </Paragraph>
      </Button>
      <Modal
        className="auto-width"
        title="Localizar Parceiros locais"
        onClose={() => setIsOpen(false)}
        show={isOpen}
      >
        <div
          style={{
            height: "auto",
            maxHeight: "311px",
            maxWidth: "481px",
            margin: "auto",
          }}
        >
          <form>
            <Title as="h5">
              Insira seu CEP para ver os parceiros de sua região.
            </Title>
            <Spacing appearance="large" />
            <Layout.Wrapper style={{ margin: "auto" }}>
              <MaskedInput
                required
                mask="cep"
                data-testid="button-cep"
                name="cep"
                label="Digite seu CEP"
                onChange={(event) => handlerOffers(event)}
                errorMessage={errorConfiguration?.message}
              />
              <Button
                style={{ maxWidth: "150px" }}
                // size="small"
                disabled={data === undefined}
                appearance="primary"
                onClick={() => handlerOpen()}
              >
                Ok
              </Button>
            </Layout.Wrapper>
          </form>
        </div>
      </Modal>
    </div>
  );
}
